<template>
  <div>
    <!-- Footer Section start -->
    <div class="copyright-section index-footer bg-light">
      <p>
        &copy; Copyright
        {{
          new Date().getFullYear() > 2020
            ? "2020 - " + new Date().getFullYear()
            : new Date().getFullYear()
        }}
        &mdash; Clean Touch Protect &mdash; Réalisation
        <a class="hover-link" href="https://altitudegp.com/">Altitude Design.</a> |
        <router-link class="hover-link" to="/mentions-legales">Mentions Légales</router-link> |
         <router-link class="hover-link" to="/rgpd">Politique de confidentialité</router-link>
      </p>
    </div>
    <!-- Footer Section End -->
    <!-- Tap on Top -->
    <div class="tap-top">
      <div>
        <i class="fa fa-angle-double-up"></i>
      </div>
    </div>
    <!-- Tap on Ends -->
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
<style scoped>
.hover-link:hover {
  color: #A9A9A9;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue